/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      TeleClaims: '$MHF_ModelNameVal_$MHF|TeleClaims',

};
